const RELOAD_KEY = 'chunk-load-reload';
const RELOAD_WINDOW_MS = 30000;

const CHUNK_ERROR_PATTERN = /Loading (CSS )?chunk [\w-]+ failed|Failed to load chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

export const isChunkLoadError = ( error: unknown ): boolean => {
    if ( !error || typeof error !== 'object' ) {
        return false;
    }

    const {
        name
        , message
    } = error as { name?: unknown; message?: unknown };

    return name === 'ChunkLoadError'
        || ( typeof message === 'string' && CHUNK_ERROR_PATTERN.test( message ) );
};

export const reloadForChunkError = (): boolean => {
    if ( typeof window === 'undefined' ) {
        return false;
    }

    try {
        const lastReload = Number( window.sessionStorage.getItem( RELOAD_KEY ) );

        if ( lastReload && Date.now() - lastReload < RELOAD_WINDOW_MS ) {
            return false;
        }

        window.sessionStorage.setItem( RELOAD_KEY, String( Date.now() ) );
    } catch {
        return false;
    }

    window.location.reload();
    return true;
};
